import { render, staticRenderFns } from "./Edit2.vue?vue&type=template&id=59be8d42&scoped=true&"
import script from "./Edit2.vue?vue&type=script&lang=js&"
export * from "./Edit2.vue?vue&type=script&lang=js&"
import style0 from "./Edit2.vue?vue&type=style&index=0&id=59be8d42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be8d42",
  null
  
)

export default component.exports